<template>
  <img :src="imageUrl" alt="Spreadshirt Logo" />
</template>

<script>
export default {
  name: 'MarketplaceLogo',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageUrl() {
      if (this.small) {
        return this.disabled
          ? '/images/marketplace_logo_small_grey40.svg'
          : '/images/marketplace_logo_small.svg';
      } else {
        return this.disabled
          ? '/images/marketplace_logo_wide_grey40.svg'
          : '/images/marketplace_logo_wide.svg';
      }
    },
  },
};
</script>
